import { PaymentElement } from "@stripe/react-stripe-js";
import { usePaymentForm } from "./payment-form.hook";
import { Loader, Modal } from "src/ui/widgets";
import { Image } from "react-bootstrap";
import { FailureIcon } from "src/assets";

export const PaymentForm = () => {
  const {
    error,
    elementOptions,
    showAlert,
    loading,
    t,
    handleSubmitPayment,
    setShowAlert,
  } = usePaymentForm();

  const ModalShowAlert = (
    <Modal
      visible={true}
      onClose={() => {
        setShowAlert(false);
      }}
      classes="d-flex justify-content-center"
    >
      <div>
        <div className="d-flex align-items-center justify-content-center">
          <Image
            src={FailureIcon}
            width={64}
            height={64}
            className="filter-F34747"
          />
        </div>
        <div className="m-3 font-14">{error || t("commons.error_label")}</div>
      </div>
    </Modal>
  );

  return (
    <>
      <div className="col-md-9 pe-md-3">
        <PaymentElement id="payment-element" options={elementOptions} />
      </div>
      <div className="justify-content-end ps-md-4 mt-5 mt-md-0">
        <button
          type="submit"
          onClick={!loading ? handleSubmitPayment : undefined}
          className="primary w-100 d-flex justify-content-center button-submit m-md-0"
        >
          {t("data_entry.payment_label")}
        </button>
        <div className="font-13 mt-2 click-height text-center">
          {t("data_entry_step_4.click_label")}
        </div>
      </div>
      <div>{showAlert && ModalShowAlert}</div>
      {loading && <Loader overlay />}
    </>
  );
};
